import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionInventoryInfoAddResource } from "../../inventory/actionInventoryInfo";
import { actionPlayerInfoAddXp } from "../../player/actionPlayerInfo";
import { actionProductionInfoConfirmRemoveProduction, TypeActionProductionInfo, } from "../actionProductionInfo";
export var epicProductionCollectProduct = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionProductionInfo.Collect), switchMap(function (action) {
        var products = action.products;
        return from([
            actionProductionInfoConfirmRemoveProduction(products.buildingId),
            actionInventoryInfoAddResource(products.product),
            actionPlayerInfoAddXp(products.xp),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epics/epicProductionCollectProduct.ts
// module id = 1937
// module chunks = 3